// extracted by mini-css-extract-plugin
export default {"walletItem":"components_walletItem__b3jE9","icon":"components_icon__cW5XZ","desc":"components_desc__9Vizh","linkBtn":"components_linkBtn__vyPma"};